<template>
  <div v-show="(!field.hide || field.hide === false)">
    <md-switch
      v-show="pageMode != 'view' && pageMode !== 'assignee'"
      v-model="form[name]"
      :key="field.label + '_input'"
      :class="[
          { 'md-valid': !$vo[name].$invalid },
          { 'md-error': $vo[name].$invalid },
          {'true': form[name] === true}
        ]"
      :disabled="field.preventEdit"
      @change="$vo[name].$touch()"
    >{{ field.label }}</md-switch>
    <div v-show="pageMode == 'view' || pageMode == 'assignee'" :key="field.label + '_output'"  class="form-field-view"><span>{{field.label}}:</span>&nbsp;<code class="md-input">{{form[name]}}</code></div>
  </div>
</template>
<script>
  export default {
    name: "crud-switch",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
    },
    data() {
      return {}
    },
  };
</script>